"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _fetchAdapter = require("./fetchAdapter");
Object.keys(_fetchAdapter).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _fetchAdapter[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _fetchAdapter[key];
    }
  });
});
//# sourceMappingURL=index.js.map